import { render, staticRenderFns } from "./review-warning.component.vue?vue&type=template&id=95abe380&scoped=true&"
import script from "./review-warning.component.vue?vue&type=script&lang=ts&"
export * from "./review-warning.component.vue?vue&type=script&lang=ts&"
import style0 from "./review-warning.component.vue?vue&type=style&index=0&id=95abe380&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95abe380",
  null
  
)

export default component.exports